const system =
    {
        // 基础后台接口链接
        baseApiUrl: 'http://api.weetionyun.com',
        basicData:'http://api.weetionyun.com/basicApplicationsSystem/indexAdminLogin', // 基础应用
        unifiedIdentityAuthentication:'http://api.weetionyun.com/adminUserSystem/indexAdminLogin', // 基础用户
        systemSettings:'http://api.weetionyun.com/baseSetSystem/indexAdminLogin', // 系统设置
        baseUploadApiUrl: 'http://api.weetionyun.com/Api/baseSystem/SystemModule/SystemFile/UploadFile',//基础后台上传文件接口链接
    }
export default system

